<style scoped>
    .vue-modal {
        display: block;
    }

    .vue-reset-button {
        margin-right: 15px;
    }
</style>

<template>
    <div style="display:inline-block">
        <button class="btn btn-primary btn-sm" @click="openModal()">
            <i class="fa fa-search" aria-hidden="true"></i>
            <span v-text="trans('main_button')"></span>
        </button>

        <div class="modal vue-modal" v-show="modal_is_opened">
            <div class="modal-dialog">
                <div class="modal-content">

                    <div class="modal-header">
                        <button type="button" class="close" @click="closeModal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" v-text="trans('title')"></h4>
                    </div>

                    <div class="modal-body clearfix">
                        <p class="lead text-mutted" v-text="trans('info')"></p>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ trans('location') }}</label>
                                    <select2
                                            name="selected_items[]"
                                            value_key="id"
                                            title_key="title"
                                            :items="locations_list"
                                            :selected="conditions.location_id"
                                            :placeholder="trans('choose_country')"
                                            @selected="(entity) => setCondition('location_id', entity.id)"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ trans('package') }}</label>
                                    <select2
                                            name="selected_items[]"
                                            value_key="id"
                                            title_key="title"
                                            :items="packages_list"
                                            :selected="conditions.package_id"
                                            :placeholder="trans('any_packages')"
                                            @selected="(entity) => setCondition('package_id', entity.id)"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ trans('is_european_union') }}</label>
                                    <select2
                                            name="selected_items[]"
                                            value_key="is_european_union"
                                            title_key="title"
                                            :items="is_european_union_list"
                                            :selected="conditions.is_european_union"
                                            :placeholder="trans('any_country')"
                                            @selected="(entity) => setCondition('is_european_union', entity.is_european_union)"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ trans('status') }}</label>
                                    <select2
                                            name="selected_items[]"
                                            value_key="id"
                                            title_key="title"
                                            :items="statuses_list"
                                            :selected="conditions.status_id"
                                            :placeholder="trans('choose_status')"
                                            @selected="(entity) => setCondition('status_id', entity.id)"
                                    />
                                </div>
                            </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>{{ trans('delivery_type') }}</label>
                              <select2
                                  name="selected_items[]"
                                  value_key="id"
                                  title_key="name"
                                  :items="delivery_types_list"
                                  :selected="conditions.delivery_type_id"
                                  :placeholder="trans('choose_delivery')"
                                  @selected="(entity) => {deliveryTypeChanged(entity.id)}"
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>{{ trans('payment_was_failed') }}</label>
                              <select2
                                  name="selected_items[]"
                                  value_key="payment_was_failed"
                                  title_key="title"
                                  :items="payment_was_failed_list"
                                  :selected="conditions.payment_was_failed"
                                  :placeholder="trans('any_payment_was_failed')"
                                  @selected="(entity) => setCondition('payment_was_failed', entity.payment_was_failed)"/>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>{{ trans('child_orders') }}</label>
                              <div>
                                <input
                                    type="checkbox"
                                    name="selected_items[]"
                                    @change="setConditionIsChild"
                                    v-model="conditions.is_child"
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button"
                                @click="findOrders"
                                class="btn btn-success pull-right"
                                v-text="trans('apply_button')"
                        ></button>
                        <button type="button"
                                @click="resetConditions"
                                class="btn btn-danger pull-right vue-reset-button"
                                v-text="trans('discard_button')"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import * as Functions from '../Functions';

    export default {
        props: ['translations', 'locations', 'packages', 'statuses', 'delivery_types'],
        data() {
            return {
                modal_is_opened: false,
                conditions: {
                    status_id: null,
                    package_id: null,
                    location_id: null,
                    is_european_union: null,
                    delivery_type_id: null,
                    payment_was_failed: null,
                    is_child: null,
                },
            };
        },
        computed: {
            filled_conditions: function () {
                let filled = {};

                Object.keys(this.conditions).forEach((key) => {
                    let value = this.conditions[key];

                    if (value !== null && value !== false) {
                        filled[key] = this.prepareFilledCondition(key, value);
                    }
                });

                return filled;
            },
            locations_list() {
                let prependLocation = [{'id': null, 'title': this.trans('choose_country')}];

                return prependLocation.concat(this.locations);
            },
            statuses_list() {
                let prependStatus = [{'id': null, 'title': this.trans('choose_status')}];

                return prependStatus.concat(this.statuses);
            },
            delivery_types_list() {
                let prependDeliveryType = [{'id': null, 'name': this.trans('choose_delivery')}];

                return prependDeliveryType.concat(this.delivery_types);
            },
            packages_list() {
                let prependPackages = [
                    {'id': null, 'title': this.trans('any_packages')},
                    {'id': 0, 'title': this.trans('no_package')}
                ];

                return prependPackages.concat(this.packages);
            },
            is_european_union_list() {
                return [
                    {'is_european_union': null, 'title': this.trans('any_country')},
                    {'is_european_union': 1, 'title': this.trans('european_union')},
                    {'is_european_union': 0, 'title': this.trans('no_european_union')}
                ];
            },
            payment_was_failed_list() {
                return [
                    {'payment_was_failed': null, 'title': this.trans('any_payment_was_failed')},
                    {'payment_was_failed': 1, 'title': this.trans('payment_was_failed')},
                    {'payment_was_failed': 0, 'title': this.trans('no_payment_was_failed')}
                ];
            },
        },
        methods: {
            prepareFilledCondition(code, value) {
                return {
                    'value': value,
                    'title': this.trans(code)
                };
            },
            // Modal
            trans(name, path = 'orders_advanced_search') {
                return Functions.trans(this.translations, name, path);
            },
            openModal() {
                this.modal_is_opened = true;
            },
            closeModal() {
                this.modal_is_opened = false;
            },
            // Buttons
            resetConditions() {
                this.clearConditions();
                this.findOrders();
            },
            findOrders() {
                this.closeModal();
                this.searchBySelected();
                this.dispatchUpdatedConditions();
            },
            clearConditions() {
                Object.keys(this.conditions).forEach((key) => {
                    this.conditions[key] = null;
                });
            },
            resetCondition(code) {
                this.conditions[code] = null;
                this.searchBySelected();
                this.dispatchUpdatedConditions();
            },
            searchBySelected() {
                this.$root.$emit('update-table', {
                    conditions: this.conditions,
                });
            },
            dispatchUpdatedConditions() {
                this.$root.$emit('update-search-conditions', this.filled_conditions);
            },
            setCondition(code, value) {
                this.conditions[code] = value;
                this.$root.$emit('unselect-checked');
            },
            setConditionIsChild() {
                if (this.conditions['is_child'] !== true) {
                    this.conditions['is_child'] = null;
                } else {
                    this.conditions['is_child'] = 1;
                };
            },
            deliveryTypeChanged(id) {
                this.setCondition('delivery_type_id', id);
                this.$root.$emit('update:delivery-type-filter', id);
            }
        },
        created: function () {
            this.$root.$on('clear-advanced-search-condition', this.resetCondition);
        },
    }
</script>
